module.exports = __webpack_public_path__ + "static/outsourcing-e3c721bada47456fcffdc3ecbb9c1f0f.png";